import React from 'react';
import { Select, FluentProvider, webLightTheme } from '@fluentui/react-components';
import IDropdownOption from '../../../utils/types/IDropdownOption';

interface IAgmAgingDropdownProps {
  onAgingUpdate: (_event: React.ChangeEvent<HTMLSelectElement>, item: IDropdownOption) => void;
  selectedOption: string;
  label: string;
}

const AgmAgingDropdown = (props: IAgmAgingDropdownProps): JSX.Element => {
  const { onAgingUpdate, selectedOption, label } = props;

  const agmAgingDateDiffOptions: IDropdownOption[] = [
    { key: null, text: '--' },
    { key: 'LESSTHAN30', text: 'Less than 30 days' },
    { key: 'OVER30', text: 'Over 30 days' },
    { key: 'BETWEEN30AND60', text: 'Between 30 and 60 days' },
    { key: 'BETWEEN60AND90', text: 'Between 60 and 90 days' },
    { key: 'BETWEEN90AND120', text: 'Between 90 and 120 days' },
    { key: 'OVER120', text: 'Over 120 days' },
  ];

  return (
    <FluentProvider theme={webLightTheme}>
      <label htmlFor="agmAgingDropdown">{label}</label>
      <Select
        id="agmAgingDropdown"
        defaultValue={selectedOption}
        onChange={(event, data): void => {
          onAgingUpdate(event, {
            key: data.value,
            text: agmAgingDateDiffOptions.find((option) => option.key === data.value)?.text || '',
          });
        }}
      >
        {agmAgingDateDiffOptions.map((option) => (
          <option value={option.key}>{option.text}</option>
        ))}
      </Select>
    </FluentProvider>
  );
};

export default AgmAgingDropdown;
